import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DataTable, SubHeading, Switch } from "../../shared/Components";
import {
  deleteAxios,
  getAxios,
  patchAxios,
} from "../../shared/Services/commonService";
import {
  API_DELETE_PERMISSION,
  API_GET_PERMISSION,
  API_UPDATE_PERMISSION,
} from "../../utils/api/ApiConstant";
import Icon from "../../assets/icons/Icon";
import { useDispatch } from "react-redux";
import { uiActions } from "../../store/ui/ui-slice";
import { dateFormat } from "../../shared/helper/common";

const Permission = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getAxios(API_GET_PERMISSION);
      setData(response || []);
    } catch (error) {
      console.error("Failed to fetch permissions:", error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleOpenModal = useCallback(
    (modalName, modalTitle, rowData = {}) => {
      dispatch(
        uiActions.openModal({
          name: modalName,
          modalTitle,
          rowData,
          size: "md",
          fetchData,
        }),
      );
    },
    [dispatch],
  );
  const handleSwitch = async (row) => {
    try {
      const updatedStatus = !row.isActive;

      const response = await patchAxios(`${API_UPDATE_PERMISSION}/${row.id}`, {
        isActive: updatedStatus,
        rowVersion: row.rowVersion,
      });
      if (response?.success) {
        setData((prevData) =>
          prevData.map((item) =>
            item.id === row.id
              ? {
                  ...item,
                  isActive: response.data.isActive,
                  rowVersion: response.data.rowVersion,
                }
              : item,
          ),
        );
      }
    } catch (error) {
      console.error("Failed to update permission:", error);
    }
  };

  const handleDelete = async (row) => {
    try {
      const response = await deleteAxios(`${API_DELETE_PERMISSION}/${row.id}`);

      setData((prevData) => {
        const index = prevData.findIndex((item) => item.id === row.id);
        return index !== -1 ? prevData.toSpliced(index, 1) : prevData;
      });
    } catch (error) {
      console.error("Failed to delete permission:", error);
    }
  };

  const handleDeleteConfirm = (rowData) => {
    dispatch(
      uiActions.openModal({
        name: "CONFIRMATION",
        showHeader: false,
        size: "sm",
        rowData: {
          modalUsesFor: {
            use: "delete",
            confirmationMessage: `Are you sure you want to delete ${rowData?.name}?`,
            onConfirm: () => handleDelete(rowData),
          },
        },
      }),
    );
  };
  const handleConfirm = (rowData) => {
    dispatch(
      uiActions.openModal({
        name: "CONFIRMATION",
        showHeader: false,
        size: "sm",
        rowData: {
          modalUsesFor: {
            use: "status",
            confirmationMessage: `Are you sure you want to ${
              rowData?.isActive ? "deactivate" : "activate"
            } ${rowData?.name}?`,
            onConfirm: () => handleSwitch(rowData),
          },
        },
      }),
    );
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "key",
        header: "Key",
      },
      {
        accessorKey: "isActive",
        header: "isActive",
        cell: ({ getValue, row }) => {
          return (
            <Switch
              getValue={getValue}
              onChange={() => handleConfirm(row.original)}
            />
          );
        },
      },
      {
        accessorKey: "actionOn",
        header: "ActionOn",
        // cell: ({ getValue }) => dateFormat(getValue()).formattedDateTime,
      },
      {
        accessorKey: "action",
        header: "Action",
        cell: ({ row }) => {
          return (
            <>
              <Icon
                name="FaEdit"
                className="icon_button"
                cursorPointer={true}
                onClick={() =>
                  handleOpenModal("PERMISSION", "Edit Permission", row.original)
                }
              />
              <Icon
                name="FaTrash"
                className=" icon_button"
                cursorPointer={true}
                onClick={() => handleDeleteConfirm(row.original)}
              />
            </>
          );
        },
      },
    ],
    [],
  );

  return (
    <>
      <SubHeading
        subTitle="Permission"
        isAdd={true}
        handleShowHide={() =>
          handleOpenModal("PERMISSION", "Create Permission")
        }
      />
      <div className="card-body">
        <DataTable
          columns={columns}
          data={data}
          isSearchable={false}
          isPagination={false}
          isPageSize={false}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default Permission;
